module.exports = __webpack_public_path__ + "img/JourneyBinderCoverPage.d8858dea.png";